import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '13.5901 7.1301'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M25.3101 1.64014C25.3101 1.64014 21.1601 3.37012 13.5901 3.37012C6.02012 3.37012 1.87012 1.64014 1.87012 1.64014C6.18012 10.8801 10.8401 12.6201 13.5901 12.6201C16.3401 12.6201 21.0001 10.8901 25.3101 1.64014Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
        />
        <path
          d="M4.77002 6.03003C4.77002 6.03003 14.24 8.01003 22.38 6.03003L20.23 8.73004C20.23 8.73004 11.37 9.78007 6.74002 8.45007L4.77002 6.03003Z"
          fill="#535659"
        />
      </g>
    </g>
  )
}
